<template>
  <div class="q-mt-sm">
    <template v-for="(item, index) in items" :key="index">
      <q-chip v-if="item.avatarText > 0 || item.key == 'no_of_coupon_zones'" square>
        <q-avatar :color="color(item)" :text-color="textColor(item)">
          {{ item.avatarText }}
        </q-avatar>
        {{ item.label }}
      </q-chip>
    </template>
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue'
export type ChipListItem = {
  color?: string
  textColor?: string
  avatarText: string | number
  key: number
  label: string
}
export default defineComponent({
  props: { items: { required: true, type: Array as PropType<ChipListItem[]> } },
  setup() {
    const color = (item: ChipListItem) => {
      return item.color ? item.color : 'grey'
    }
    const textColor = (item: ChipListItem) => {
      return item.textColor ? item.textColor : 'white'
    }
    return {
      color,
      textColor,
    }
  },
})
</script>
